import { render, staticRenderFns } from "./IdentifyProvider.vue?vue&type=template&id=7be94cc7&scoped=true&"
import script from "./IdentifyProvider.vue?vue&type=script&lang=ts&"
export * from "./IdentifyProvider.vue?vue&type=script&lang=ts&"
import style0 from "./IdentifyProvider.vue?vue&type=style&index=0&id=7be94cc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be94cc7",
  null
  
)

export default component.exports